import type {
  ReportStrategyDetailResponse,
  ReportStrategyPolicyVersion,
} from "../types/reports";

/** True when this version is the strategy's current overlay (Confirm provenance or published). */
export function isCurrentReportStrategyPolicyVersion(
  version: Pick<ReportStrategyPolicyVersion, "id" | "is_current">,
  detail: Pick<ReportStrategyDetailResponse, "current_policy_version_id"> | null | undefined
): boolean {
  if (version.is_current === true) return true;
  const currentId = detail?.current_policy_version_id?.trim();
  if (!currentId) return false;
  return String(version.id) === String(currentId);
}

/**
 * Policy tree for journal simulate / Run prefill.
 * Prefer BE `effective_policy_tree` (overlay + Strategy R&D core underlay) when this
 * version is current — never FE-rebuild Confirm exits from research_sim.
 */
export function resolvePolicyTreeForSimulate(opts: {
  version: ReportStrategyPolicyVersion;
  detail?: ReportStrategyDetailResponse | null;
}): unknown | null | undefined {
  const { version, detail } = opts;
  if (
    detail?.effective_policy_tree != null &&
    isCurrentReportStrategyPolicyVersion(version, detail)
  ) {
    return detail.effective_policy_tree;
  }
  return version.policy_tree;
}

/** Confirm v2 provenance-only overlay (empty segments; core exits live under research_sim). */
export function isStrategyRdConfirmProvenanceTree(tree: unknown): boolean {
  if (tree == null || typeof tree !== "object" || Array.isArray(tree)) return false;
  const meta = (tree as { meta?: unknown }).meta;
  if (meta == null || typeof meta !== "object" || Array.isArray(meta)) return false;
  const rd = (meta as { strategy_rd?: unknown }).strategy_rd;
  if (rd == null || typeof rd !== "object" || Array.isArray(rd)) return false;
  const source = (rd as { source?: unknown }).source;
  return (
    source === "confirm_v2_core" ||
    source === "confirm_v1" ||
    source === "strategy_rd_confirm_v1"
  );
}
